export function formatNumber(number, decimalPlaces = 2) {
  if (number == null || Number.isNaN(Number(number))) return "—";
  return Number(number).toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });
}

export function formatDateToLocal(dateString) {
  if (!dateString) return "N/A";
  try {
    return new Date(dateString).toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  } catch {
    return "N/A";
  }
}

export const getStatusLabel = (status) => {
  if (!status) return "Recorded";
  return String(status)
    .toLowerCase()
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const isPendingStatus = (status) =>
  ["pending", "processing", "in_progress", "submitted"].includes(
    String(status || "").toLowerCase(),
  );

export const isRejectedStatus = (status) =>
  ["rejected", "failed", "cancelled", "declined"].includes(
    String(status || "").toLowerCase(),
  );

export const getTransactionTitle = (record) => {
  const recipientName = `${record?.recipientFirstName || ""} ${record?.recipientLastName || ""}`.trim();
  const paymentMethod = String(record?.paymentMethod || "").trim();

  if (record?.type === "REMITTANCE") {
    return recipientName ? `Send to ${recipientName}` : "Send";
  }
  if (record?.type === "WALLET_TRANSFER") {
    if (record?.direction === "DEBIT") {
      return recipientName ? `Send to ${recipientName}` : "Send";
    }
    return recipientName ? `Receive from ${recipientName}` : "Receive";
  }
  if (record?.type === "ADD_FUND") {
    return paymentMethod ? `Add Funds via ${paymentMethod}` : "Add Funds";
  }
  return "Withdraw";
};

export const getTypeLabel = (record) => {
  if (record?.type === "ADD_FUND") return "Add Funds";
  if (record?.type === "ADJUSTMENT") return "Withdraw";
  if (record?.type === "REMITTANCE") return "Send";
  if (record?.type === "WALLET_TRANSFER") {
    return record?.direction === "DEBIT" ? "Send" : "Receive";
  }
  return record?.type || "Transaction";
};

export const getRecipientLabel = (record) => {
  const recipientName = `${record?.recipientFirstName || ""} ${record?.recipientLastName || ""}`.trim();
  if (record?.type === "REMITTANCE") {
    return recipientName || "Remittance";
  }
  if (record?.type === "WALLET_TRANSFER") {
    return recipientName ||
      (record?.direction === "DEBIT" ? "Wallet transfer" : "Wallet receipt");
  }
  if (record?.type === "ADD_FUND") return record?.paymentMethod || "Wallet funding";
  if (record?.type === "ADJUSTMENT") return record?.reason || "Account adjustment";
  return "—";
};
